import React, {
  FC,
} from 'react';
import { Box, Cab } from '../../../../lib/types';
import CreateUser from '../../Role/User/CreateUser';
import OpenBox from '../../Role/User/OpenBox/Code/OpenBox';
import OpenBoxSuccess from '../../Role/User/OpenBox/Code/OpenBoxSuccess';
import ReopenBox from '../../Role/User/ReopenBox/Code/ReopenBox';
import ReopenBoxSuccess from '../../Role/User/ReopenBox/Code/ReopenBoxSuccess';
import SelectPlatform from '../../Role/User/OpenBox/SelectPlatform';
import InputRoomNo from '../../Role/User/OpenBox/RoomNo/OpenBox';
import RoomNoOpenBoxSuccess from '../../Role/User/OpenBox/RoomNo/OpenBoxSuccess';
import RoomNoReopenBox from '../../Role/User/ReopenBox/RoomNo/ReopenBox';
import RoomNoReopenBoxSuccess from '../../Role/User/ReopenBox/RoomNo/ReopenBoxSuccess';
import ReopenSelectPlatform from '../../Role/User/ReopenBox/SelectPlatform';
import OfflineOpenBox from '../../Role/User/OpenBox/OfflineOpenBox';

const UserLink: FC<Props> = ({
  targetPage,
  cabId32Str,
  setTargetPage,
  isEnglish,
  setIsEnglish,
  cab,
  orderId,
  userId,
  pickupCode,
  selectedPlatform,
  pickupRoomNo,
  setShowLoading,
  setUserId,
  setPhoneNumber,
  setPickupCode,
  setOrderId,
  setSelectedPlatform,
  setPickupRoomNo,
  setOpenedBoxes,
  openedBoxes,
}) => {
  // 创建用户页面
  if (targetPage === 'create-user') {
    return (
      <CreateUser
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        cab={cab}
        setShowLoading={setShowLoading}
        setUserId={setUserId}
        setPhoneNumber={setPhoneNumber}
      />
    );
  }

  // 用户输入房间号取餐页面
  if (targetPage === 'room-num-open-box' && selectedPlatform && userId) {
    return (
      <InputRoomNo
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        cab={cab}
        setShowLoading={setShowLoading}
        setOpenedBoxes={setOpenedBoxes}
        platform={selectedPlatform}
        userId={userId}
        setPickupRoomNo={setPickupRoomNo}
        setOrderId={setOrderId}
        setSelectedPlatform={setSelectedPlatform}
      />
    );
  }

  // 用户使用房间号租用开柜成功页面
  if (targetPage === 'room-num-open-box-success' && selectedPlatform && userId && openedBoxes.length > 0 && pickupRoomNo && orderId) {
    return (
      <RoomNoOpenBoxSuccess
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        setShowLoading={setShowLoading}
        userId={userId}
        openedBoxes={openedBoxes}
        roomNo={pickupRoomNo}
        platform={selectedPlatform}
        orderId={orderId}
        setSelectedPlatform={setSelectedPlatform}
      />
    );
  }

  // 用户输入取餐码取餐页面
  if (targetPage === 'pickup-code-open-box' && userId && selectedPlatform) {
    return (
      <OpenBox
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        setShowLoading={setShowLoading}
        setOpenedBoxes={setOpenedBoxes}
        cab={cab}
        userId={userId}
        setPickupCode={setPickupCode}
        setOrderId={setOrderId}
        selectedPlatform={selectedPlatform}
        setSelectedPlatform={setSelectedPlatform}
      />
    );
  }

  // 用户选择平台
  if (targetPage === 'select-platform' && userId) {
    return (
      <SelectPlatform
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        selectedPlatform={selectedPlatform}
        setSelectedPlatform={setSelectedPlatform}
      />
    );
  }

  // 用户选择平台重新打开柜门页面
  if (targetPage === 'platform-select-reopen-box') {
    return (
      <ReopenSelectPlatform
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        selectedPlatform={selectedPlatform}
        setSelectedPlatform={setSelectedPlatform}
        setShowLoading={setShowLoading}
      />
    );
  }

  // 用户取餐开柜成功页面
  if (targetPage === 'user-open-box-success' && selectedPlatform && userId && openedBoxes.length > 0 && orderId && pickupCode) {
    return (
      <OpenBoxSuccess
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        setShowLoading={setShowLoading}
        userId={userId}
        orderId={orderId}
        pickupCode={pickupCode}
        openedBoxes={openedBoxes}
        platform={selectedPlatform}
        setSelectedPlatform={setSelectedPlatform}
      />
    );
  }

  // 用户重新输入取餐码重新开柜页面
  if (targetPage === 'user-reopen-box' && selectedPlatform) {
    return (
      <ReopenBox
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        setShowLoading={setShowLoading}
        setOpenedBoxes={setOpenedBoxes}
        cab={cab}
        setPickupCode={setPickupCode}
        setOrderId={setOrderId}
        selectedPlatform={selectedPlatform}
        setSelectedPlatform={setSelectedPlatform}
      />
    );
  }

  // 用户重新开柜成功页面
  if (targetPage === 'user-reopen-box-success' && userId && openedBoxes.length > 0) {
    return (
      <ReopenBoxSuccess
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        setShowLoading={setShowLoading}
        userId={userId}
        openedBoxes={openedBoxes}
        setSelectedPlatform={setSelectedPlatform}
      />
    );
  }

  // 用户输入房间号重新开柜页面
  if (targetPage === 'room-num-reopen-box' && userId && selectedPlatform) {
    return (
      <RoomNoReopenBox
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        cab={cab}
        userId={userId}
        platform={selectedPlatform}
        setShowLoading={setShowLoading}
        setOpenedBoxes={setOpenedBoxes}
        setPickupRoomNo={setPickupRoomNo}
        setSelectedPlatform={setSelectedPlatform}
      />
    );
  }

  // 用户输入房间号重新开柜成功页面
  if (targetPage === 'room-num-reopen-box-success' && userId && openedBoxes.length > 0) {
    return (
      <RoomNoReopenBoxSuccess
        cabId32Str={cabId32Str}
        setTargetPage={setTargetPage}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        userId={userId}
        setShowLoading={setShowLoading}
        openedBoxes={openedBoxes}
        setSelectedPlatform={setSelectedPlatform}
      />
    );
  }

  // 离线二维码取餐页面
  if (targetPage === 'offline-code-open-box' && userId && (pickupCode || pickupRoomNo)) {
    return (
      <OfflineOpenBox
        cabId32Str={cabId32Str}
        cab={cab}
        userId={userId}
        pickupCode={pickupCode}
        pickupRoomNo={pickupRoomNo}
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        setShowLoading={setShowLoading}
        setTargetPage={setTargetPage}
      />
    );
  }

  return <></>;
};

export interface Props {
  targetPage: string;
  cabId32Str: string;
  isEnglish: boolean;
  cab: Cab,
  userId?: number;
  phoneNumber?: number;
  orderId?: number;
  pickupCode?: string;
  pickupRoomNo?: string;
  selectedPlatform?: number;
  setTargetPage: (page: string) => void;
  setIsEnglish: (isEn: boolean) => void;
  setShowLoading: (show: boolean) => void;
  setUserId: (id: number) => void;
  setPhoneNumber: (phoneNumber: number) => void;
  setPickupCode: (code: string) => void;
  setOrderId: (id?: number) => void;
  setSelectedPlatform: (platform?: number) => void;
  setPickupRoomNo: (roomNo?: string) => void;
  setOpenedBoxes: (openedBoxes: Box[]) => void;
  openedBoxes: Box[];
}

export default UserLink;
